var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 29,
    viewBox: "0 0 91 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3505_35007)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 29,
    rx: 14.5,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5938 8.85156V8.86021",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5939 15.315L30.3664 10.6995C30.0542 10.1369 29.8944 9.50257 29.9026 8.85925C29.9109 8.21593 30.0869 7.5859 30.4134 7.0315C30.7398 6.47709 31.2053 6.0175 31.7639 5.6982C32.3224 5.3789 32.9547 5.21094 33.598 5.21094C34.2414 5.21094 34.8736 5.3789 35.4322 5.6982C35.9907 6.0175 36.4562 6.47709 36.7827 7.0315C37.1091 7.5859 37.2852 8.21593 37.2934 8.85925C37.3017 9.50257 37.1418 10.1369 36.8297 10.6995L33.5939 15.315Z",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6717 7.69377L25.2838 7.00391L19.7402 9.77156V21.7866L25.2838 19.0108L30.8273 21.7866L36.3708 19.0108V17.1629",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2832 7.00391V19.0108",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8262 17.1641V21.7878",
    stroke: "#596475",
    strokeWidth: 1.47827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0006 14.5026L51.6043 8.93264H49.169V18H50.8789V11.0959L53.2623 16.5363H54.739L57.1224 11.0959V18H58.8322V8.93264H56.41L54.0006 14.5026ZM63.5201 10.8109C62.5875 10.8109 61.4605 11.044 60.5797 11.329L60.8647 12.456C61.6419 12.2228 62.4838 12.0544 63.1444 12.0544C63.9994 12.0415 64.375 12.3264 64.4268 13.2591C61.4087 13.3497 60.1393 14.3601 60.1393 15.9404C60.1393 17.2487 61.046 18.0648 62.4061 18.0648C63.2351 18.0648 63.9605 17.7668 64.4268 17.1451V18H66.0849V13.4275C66.0849 11.4585 65.3206 10.8109 63.5201 10.8109ZM62.9761 16.7435C62.1859 16.7435 61.8102 16.329 61.8102 15.7461C61.8102 15.0855 62.3154 14.4896 64.4268 14.3601V15.1762C64.4268 16.3031 63.7273 16.7306 62.9761 16.7435ZM71.395 10.8238C70.566 10.8238 69.8795 11.1218 69.452 11.6399V10.8756H67.7422V20.5907H69.452V17.2617C69.8924 17.7798 70.5789 18.0518 71.395 18.0518C73.3639 18.0518 74.3354 16.7953 74.3354 14.4378C74.3354 12.0803 73.3639 10.8238 71.395 10.8238ZM70.9935 16.8601C69.9054 16.8601 69.3743 16.044 69.3743 14.4378C69.3743 12.8316 69.9054 12.0155 70.9935 12.0155C72.0945 12.0155 72.6126 12.8316 72.6126 14.4378C72.6126 16.044 72.0945 16.8601 70.9935 16.8601Z",
    fill: "#596475"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3505_35007",
    x: -7,
    y: -7,
    width: 105,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3505_35007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3505_35007",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapButton);
export default __webpack_public_path__ + "static/media/map_button.764632bac47a2faf4412a466fa014c86.svg";
export { ForwardRef as ReactComponent };